export const departmentPosition = (department: string) => {
    switch (department) {
        case '01':
            return { lat: 46.0650793, lng: 4.887258 };
        case '02':
            return { lat: 49.4528855, lng: 3.0451531 };
        case '03':
            return { lat: 46.3670797, lng: 2.5794706 };
        case '04':
            return { lat: 44.1594009, lng: 5.0852625 };
        case '05':
            return { lat: 44.6562615, lng: 5.6859646 };
        case '06':
            return { lat: 43.9204103, lng: 6.6154259 };
        case '07':
            return { lat: 44.8148628, lng: 3.8119917 };
        case '08':
            return { lat: 49.6975885, lng: 4.1475996 };
        case '09':
            return { lat: 42.9434716, lng: 0.9391304 };
        case '10':
            return { lat: 48.319748, lng: 3.5623528 };
        case '11':
            return { lat: 43.0541074, lng: 1.9024915 };
        case '12':
            return { lat: 44.2949701, lng: 0.3486023 };
        case '13':
            return { lat: 43.5403798, lng: 4.4600267 };
        case '14':
            return { lat: 49.0903448, lng: -0.9184226 };
        case '15':
            return { lat: 45.049211, lng: 2.1553705 };
        case '16':
            return { lat: 45.6658413, lng: -0.3198145 };
        case '17':
            return { lat: 45.7296761, lng: -1.3401684 };
        case '18':
            return { lat: 47.0243562, lng: 1.864916 };
        case '19':
            return { lat: 45.3678652, lng: 1.7286636 };
        case '20':
            return { lat: 42.1875198, lng: 8.4898887 };
        case '21':
            return { lat: 47.4607708, lng: 3.6443937 };
        case '22':
            return { lat: 48.466327, lng: -3.3492537 };
        case '23':
            return { lat: 46.0590327, lng: 1.430148 };
        case '24':
            return { lat: 45.1423349, lng: 0.1413842 };
        case '25':
            return { lat: 47.0055743, lng: 6.3065039 };
        case '26':
            return { lat: 44.729329, lng: 4.6768592 };
        case '27':
            return { lat: 49.0753969, lng: 0.4880154 };
        case '28':
            return { lat: 48.4426346, lng: 0.2275649 };
        case '29':
            return { lat: 48.2269544, lng: -4.8257308 };
        case '30':
            return { lat: 43.9595209, lng: 3.4922118 };
        case '31':
            return { lat: 43.2844363, lng: 1.0521793 };
        case '32':
            return { lat: 43.6328803, lng: -0.0263082 };
        case '33':
            return { lat: 44.8989809, lng: -1.0347212 };
        case '34':
            return { lat: 43.5911054, lng: 2.8052545 };
        case '35':
            return { lat: 48.1762418, lng: -2.2143977 };
        case '36':
            return { lat: 46.8117484, lng: 0.9741951 };
        case '37':
            return { lat: 47.2184957, lng: -0.4381984 };
        case '38':
            return { lat: 45.2892204, lng: 4.9888788 };
        case '39':
            return { lat: 46.7828675, lng: 5.1678272 };
        case '40':
            return { lat: 44.0095013, lng: -1.2552142 };
        case '41':
            return { lat: 47.6387445, lng: -0.8825494 };
        case '42':
            return { lat: 45.7533815, lng: 3.6626071 };
        case '43':
            return { lat: 45.0810046, lng: 2.6388716 };
        case '44':
            return { lat: 47.3475655, lng: -2.3479885 };
        case '45':
            return { lat: 47.9135364, lng: 1.7587415 };
        case '46':
            return { lat: 44.6246003, lng: 1.0344066 };
        case '47':
            return { lat: 44.3643563, lng: -0.6788288 };
        case '48':
            return { lat: 44.5422712, lng: 2.9279894 };
        case '49':
            return { lat: 47.3889967, lng: -1.12161 };
        case '50':
            return { lat: 49.0913387, lng: -1.9034312 };
        case '51':
            return { lat: 48.9610678, lng: 3.6560189 };
        case '52':
            return { lat: 48.1324755, lng: 4.6969924 };
        case '53':
            return { lat: 48.1502443, lng: -1.2057454 };
        case '54':
            return { lat: 48.9351218, lng: 3.9780509 };
        case '55':
            return { lat: 49.0124554, lng: 4.8095156 };
        case '56':
            return { lat: 47.723325, lng: -5.1818566 };
        case '57':
            return { lat: 49.02045, lng: 6.2041744 };
        case '58':
            return { lat: 47.1192098, lng: 2.976614 };
        case '59':
            return { lat: 50.5285411, lng: 2.5987193 };
        case '60':
            return { lat: 49.40741, lng: 1.2797631 };
        case '61':
            return { lat: 48.5757578, lng: -0.5037872 };
        case '62':
            return { lat: 50.5144634, lng: 1.8101397 };
        case '63':
            return { lat: 45.7714118, lng: 2.6249107 };
        case '64':
            return { lat: 43.1868104, lng: -1.4430632 };
        case '65':
            return { lat: 43.1429396, lng: -0.4023297 };
        case '66':
            return { lat: 42.6254113, lng: 1.8879398 };
        case '67':
            return { lat: 48.5986378, lng: 7.02531 };
        case '68':
            return { lat: 47.8653708, lng: 6.6697806 };
        case '69':
            return { lat: 45.8798834, lng: 4.1400944 };
        case '70':
            return { lat: 47.6378929, lng: 5.5341481 };
        case '71':
            return { lat: 46.6554816, lng: 3.9821479 };
        case '72':
            return { lat: 48.0262667, lng: -0.3274893 };
        case '73':
            return { lat: 45.4946924, lng: 5.8419416 };
        case '74':
            return { lat: 46.0450765, lng: 6.1437048 };
        case '75':
            return { lat: 48.8589465, lng: 2.2768237 };
        case '76':
            return { lat: 49.6404966, lng: -1.3683575 };
        case '77':
            return { lat: 48.6185328, lng: 2.4138984 };
        case '78':
            return { lat: 48.7620947, lng: 1.556856 };
        case '79':
            return { lat: 46.5386751, lng: -0.9033519 };
        case '80':
            return { lat: 49.9685856, lng: 1.7297115 };
        case '81':
            return { lat: 43.791491, lng: 1.674533 };
        case '82':
            return { lat: 44.0808933, lng: 1.0884833 };
        case '83':
            return { lat: 43.3950663, lng: 5.7328855 };
        case '84':
            return { lat: 44.0452819, lng: 4.9223427 };
        case '85':
            return { lat: 46.6547384, lng: -3.766248 };
        case '86':
            return { lat: 46.6116952, lng: -0.0076924 };
        case '87':
            return { lat: 45.9143142, lng: 0.1225365 };
        case '88':
            return { lat: 48.1630107, lng: 5.7342024 };
        case '89':
            return { lat: 47.8547548, lng: 3.0325829 };
        case '90':
            return { lat: 47.628219, lng: 6.3762278 };
        case '91':
            return { lat: 8.5304599, lng: 1.9692229 };
        case '92':
            return { lat: 48.8403004, lng: 2.1009135 };
        case '93':
            return { lat: 48.9099314, lng: 2.3053956 };
        case '94':
            return { lat: 48.7746509, lng: 2.3919764 };
        case '95':
            return { lat: 49.0751802, lng: 1.8210086 };
        default:
            return { lat: 47.5808147, lng: 3.2221468 };
    }
};
